import * as React from 'react';
import { Impairments } from '../../Profile/ProfileFields';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import { styles } from './Styles';

import uniq from 'lodash/uniq';
import flatMap from 'lodash/flatMap';
import includes from 'lodash/includes';
const CONDITIONS = require('../../Profile/Conditions.json').conditions as any;
const FN_TO_CONDITION = (Object.assign as any)(...(flatMap(CONDITIONS.map((condition, id) => condition.functions.map(fn => ({[fn.id]:condition.id}))))));

class ImpairmentWizard extends React.Component<any,any> {
		constructor(props) {
				super(props);
				this.state = {selected: 0};
		}

		toggleCondition(id) {
				this.setState({ selected: this.state.selected == id ? -1 : id });
		}

		render() {
				const { selected_disability_areas, relationship, firstName } = this.props;
				const { selected } = this.state;
    //const shown_functions = functions;
    //const shown_functions = uniq(functions.filter((fn, idx) => fn.severity).map((fn) => FN_TO_CONDITION[fn.id])) as any;
				//const shown_functions = functions.map((fn, idx) => fn && fn.severity && idx).filter((v)=>isNumber(v));
    //const shown = shown_functions;
    //const wtf = CONDITIONS.filter((val,id) => shown && includes(shown, val.id) || !shown)

				return (
						<fieldset  className={styles.fieldset}>
								<legend className={styles.legend}>Health Information</legend>
                {selected_disability_areas.length ? (
                     <div style={{'display': 'flex', 'align-items': 'stretch'}}>
										 <span>Indicate the severities of <b>{relationship == 'myself' ? 'your' : `${firstName}'s'`}</b> health conditions...</span>
										 <Impairments selected={[selected]} onClick={this.toggleCondition.bind(this)} show={selected_disability_areas} />
								</div>) : <span>
                    You didn't select any impairment categories. Press <strong>next</strong> to confirm or back to change your selection.
                </span>}
						</fieldset>
				);
		}
}

export default connect(state => ({
		selected_disability_areas: get(getFormValues('Wizard')(state), 'selected_disability_areas', [])
}))(ImpairmentWizard);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Health3.tsx